import React from 'react';
import './tailor.css';
import aboutIMG from '../../assets/logo/about.png'

const Tailor = () => {
  return (
    <div className="about">
      <div className="about__bg"></div>
      <div className="about__orb about-orb-1"></div>
      <div className="about__orb about-orb-2"></div>
      
      <div className="about__container">
        <nav className="holographic__nav">
          <a href='/tailor' className="nav__item nav__item--active">About</a>
          <a href='/tailorprofiles' className="nav__item">Tailors</a>
          <a href='/tailorservices' className="nav__item">Services</a>
        </nav>

        <main className="about__content">
          <div className="about__wrapper">
            <div className="about__text">
              <div className="about__accent"></div>
              <h2 className="about__title">
                Redefining Fashion Through Precision & Innovation
              </h2>
              <span className="about__subtitle">THE FUTURE OF BESPOKE TAILORING</span>
              
              <p className="about__description">
                At <span className="about__highlight">ENERSTIC</span>, we believe that clothing should be as unique as the individual wearing it. 
                Our approach combines centuries-old tailoring techniques with cutting-edge technology to create 
                garments that are not just worn, but experienced.
              </p>
              
              <p className="about__description">
                Each piece is crafted with meticulous attention to detail, from the initial consultation to 
                the final stitch. We source only the finest materials and employ innovative methods to ensure 
                your clothing moves with you, adapts to your lifestyle, and stands the test of time.
              </p>

              <div className="about__divider"></div>

              <div className="about__features">
                <div className="about__feature">
                  <i className="fas fa-check"></i>
                  <span>Advanced pattern-making technology</span>
                </div>
                <div className="about__feature">
                  <i className="fas fa-check"></i>
                  <span>Sustainable and ethical practices</span>
                </div>
                <div className="about__feature">
                  <i className="fas fa-check"></i>
                  <span>Global material sourcing network</span>
                </div>
                <div className="about__feature">
                  <i className="fas fa-check"></i>
                  <span>Lifetime alteration guarantee</span>
                </div>
              </div>
            </div>

            <div className="about__image">
              <div className="about__img-container">
                <img src={aboutIMG} alt="about__img" className="about__img" />
                <div className="about__img-overlay">
                  {/* <div className="about__img-text">
                    CRAFTING TOMORROW'S FASHION TODAY
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Tailor;